<template>

  <v-menu v-model="menuVisible" location="bottom" class="userstagmenu" :close-on-content-click="false"
    transition="slide-y-transition" width="280" max-height="350" offset-y>
    <template v-slot:activator="{ props }">
      <div class="w-100">
        <div class="k-card-border-hover">
          <assignees class="my-auto chip-w-100 cursor-pointer w-100" full_with :users="users" :type="type"
            :selected="selected" :show_names="show_names" :size="size" show_companyname v-bind="props"
            :placeholder="placeholder">
          </assignees>
        </div>
        <div v-if="errorMessages" class="pl-4 pt-2 v-messages__message" style="color:rgb(var(--v-theme-error))"><small>{{ errorMessages
            }}</small></div>
      </div>
    </template>

    <v-card class="pa-2 k-card-border user-list-group">
      <v-text-field class="sticky-top-input" v-model="search" prepend-inner-icon="fal fa-search" placeholder="Zoeken"
        variant="solo" density="compact" hide-details></v-text-field>
      <v-list density="compact" class="px-0" nav v-if="filteredUsers.length > 0">
        <v-list-subheader>Gebruikers</v-list-subheader>
        <v-list-item v-for="item in filteredUsers" :key="item.id" @click="update(item.id)"
          class="px-1 py-0 cursor-pointer">
          <assignees class="my-auto chip-w-100" :users="users" show_companyname :size="35" :show_names="true" full_with
            :type="type" :selected="item.id" :value="selected" />
        </v-list-item>
      </v-list>
      <v-list density="compact" nav v-else>
        <v-list-item>
          <v-list-item>
            <v-list-item-title class="text-center">Geen gebruikers gevonden</v-list-item-title>
            <v-btn v-if="add_user" @click="AddUserDialog" block class="btn mt-3 btn-sm btn-primary btn-block"
              color="primary">Toevoegen</v-btn>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-card>
    <v-dialog v-model="add_user_dialog" width="600" content-class="card card-sm">
      <AddDebtorDialog @update:close="add_user_dialog = false" @form-submitted="createDebtor" />
    </v-dialog>
  </v-menu>

</template>

<script>
import AddDebtorDialog from '@/components/debtors/dialogs/AddDebtorDialog.vue';
import ds from '@/services/DebtorServices.js';

export default {
  name: "UsersChipMenu",
  props: {
    users: { type: Array, required: true },
    type: { type: String, default: "chip" },
    selected: { type: Number, required: true },
    full_with: { type: Boolean, default: false },
    size: { type: String, default: "large" },
    ticket_id: { type: Number, default: null },
    show_names: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    add_user: { type: Boolean, default: false },
    errorMessages: { type: String, default: "" },
  },

  data: () => ({
    menuVisible: false,
    search: "",
    add_user_dialog: false,

  }),
  components: {
    AddDebtorDialog
  },
  methods: {

    AddUserDialog() {
      this.add_user_dialog = true;
    },

    async createDebtor(data) {
      try {
        const response = await ds.adddebtor(data);

        if (response.success && response.data && response.data.debtor) {
          const debtorUser = response.data.debtor.user; // Haal user-info uit debtor

          if (debtorUser) {
            this.users.push({
              id: debtorUser.id,
              first_name: debtorUser.first_name,
              last_name: debtorUser.last_name,
              email: debtorUser.email,
              debtor_id: debtorUser.debtor_id
            });
            // this.selected = debtorUser.id;
          } else {
            console.error("User info ontbreekt in response:", response.data.debtor);
          }

          this.add_user_dialog = false;

          this.$toast.success(response.message || "Debtor added successfully.");
        }

      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to add debtor.");
      }
    },
    update(usersId) {
      if (this.ticket_id) {
        this.$emit('update:value', { usersId, ticketId: this.ticket_id });
      } else {
        this.$emit('update:value', usersId);
      }
      this.menuVisible = false;
    }
  },
  computed: {
    filteredUsers() {
      if (!this.users || !Array.isArray(this.users)) {
        return []; // Fallback voor als users niet goed is
      }
      if (!this.search) {
        return this.users; // Geen zoekterm, toon alle gebruikers
      }

      const searchTerm = this.search.toLowerCase();

      return this.users.filter(user => {
        return (
          user.first_name.toLowerCase().includes(searchTerm) ||
          user.last_name.toLowerCase().includes(searchTerm) ||
          user.email.toLowerCase().includes(searchTerm) ||
          user.id.toString().includes(searchTerm) ||
          (user.company_name ? user.company_name.toLowerCase().includes(searchTerm) : false)
        );

      });
    },

    selectedItem() {
      return this.users.find(item => item.id === this.selected) || 0;
    },
  }

};
</script>
